<template>
  <div class="pt-2 d-flex" style="overflow-y: hidden">
    <v-card flat class="d-flex flex-column flex-grow-1 flex-shrink-1">
      <v-form v-model="valid" class="flex-grow-0 flex-shrink-0">
        <v-row no-gutters align="center" justify="space-around">
          <v-col cols="12" sm="1" style="text-align: right">
            <label>任务名称:</label>
          </v-col>
          <v-col cols="12" sm="2">
            <v-text-field
                class="form-item-value"
                v-model="filter.taskName"
                label=""
                outlined
                dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="1" style="text-align: right">
            <label>适用门店:</label>
          </v-col>
          <v-col cols="12" sm="2">
            <pd-shop-multiple-list v-model="filter.shopIds" isSearch></pd-shop-multiple-list>
          </v-col>
          <v-col cols="12" sm="2"></v-col>
          <v-col cols="12" sm="2">
            <v-btn color="primary" class="mr-2" depressed @click="handleSearch" v-if="_hasButtonPermission('查询')"
            >查询</v-btn
            >
            <v-btn depressed @click="handleResetSearch" v-if="_hasButtonPermission('查询')">重置</v-btn>
          </v-col>
        </v-row>
      </v-form>
      <div class="flex-grow-1 flex-shrink-1" style="position: relative">
        <div style="position: absolute; inset: 0px">
      <v-data-table
          ref="data"
          :headers="headers"
          fixed-header
          height="calc(100% - 64px - 59px)"
          style="height: 100%"
          :items="desserts"
          class="elevation-1 mt-2"
          :loading="loading"
          :server-items-length="totalDesserts"
          :page.sync="filter.pageNum"
          :items-per-page.sync="filter.pageSize"
          @update:page="handlePageChanged"
          @update:items-per-page="handlePageSizeChanged"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" depressed class="mr-2" @click="add" v-if="_hasButtonPermission('新增巡检任务')">
              新增巡检任务
            </v-btn>
            <v-btn color="primary" depressed class="mr-2" @click="doExport" v-if="_hasButtonPermission('查询')">
              导出
            </v-btn>
          </v-toolbar>
        </template>

        <template v-slot:[`item.shopNames`]="{ item }">
          {{ item.shopNames.length > 30 ? item.shopNames.substr(0,30) + '...' : item.shopNames }}
        </template>
        <template v-slot:[`item.taskType`]="{ item }">
          {{ item.taskType ==1 ? '周期任务' : '' }}
        </template>
        <template v-slot:[`item.cycleType`]="{ item }">
          {{ edit.cycleTypeList[item.cycleType - 1].name }}
        </template>
        <template v-slot:[`item.statType`]="{ item }">
          {{ edit.statTypeList[item.statType - 1].name }}
        </template>
        <template v-slot:[`item.startDate`]="{ item }">
          {{ item.startDate + ' ~ ' + item.endDate }}
        </template>
        <template v-slot:[`item.startTime`]="{ item }">
          {{ item.startTime + ' ~ ' + item.endTime }}
        </template>
        <template v-slot:[`item.status`]="{ item }">
          {{ item.status === 2 ? "停用" : "启用" }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom v-if="_hasButtonPermission('修改')">
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" @click="editItem(item)" v-bind="attrs" v-on="on">
                mdi-pencil
              </v-icon>
            </template>
            <span>修改</span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.status===1 && _hasButtonPermission('停用')">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="item.status===1" small @click="disableItem(item)" v-bind="attrs" v-on="on"> mdi-close-circle </v-icon>
            </template>
            <span>停用</span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.status===0 && _hasButtonPermission('启用')">
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-if="item.status===0" small @click="enableItem(item)" v-bind="attrs" v-on="on"> mdi-check-circle </v-icon>
            </template>
            <span>启用</span>
          </v-tooltip>
        </template>
      </v-data-table>
        </div>
      </div>
      <!--修改弹窗-->
      <v-dialog v-model="edit.dialog" width="800">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >{{ edit.title }}</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-form ref="taskForm">
              <v-row align="center">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>任务名称:</label>
                </v-col>
                <v-col cols="7">
                  <v-text-field v-model="edit.item.taskName" outlined dense :rules="[rules.required]"></v-text-field>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>适用门店:</label>
                </v-col>
                <v-col cols="7">
                  <pd-shop-multiple-list :rules="[rules.required]"
                      v-model="edit.item.shopIds"
                  ></pd-shop-multiple-list>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>任务类型:</label>
                </v-col>
                <v-col cols="7">
                  <v-select :rules="[rules.required]" :items="edit.taskTypeList" v-model="edit.item.taskType" item-value="id" item-text="name" outlined dense></v-select>
                </v-col>
              </v-row>
			  <v-row align="center">
					<v-col cols="3" class="text-right">
						<label><label class="red--text">*</label>任务版块:</label>
					</v-col>
					<v-col cols="7">
						<v-select :rules="[rules.required]" :items="edit.forumList" v-model="edit.item.forumId" item-value="id"
						 item-text="forumName" outlined dense></v-select>
					</v-col>
				</v-row>
              <v-row align="center">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>循环类型:</label>
                </v-col>
                <v-col cols="7">
                  <v-select :rules="[rules.required]" :items="edit.cycleTypeList" v-model="edit.item.cycleType" item-value="id" item-text="name" outlined dense></v-select>
                </v-col>
              </v-row>
              <v-row align="center" v-if="edit.item.cycleType == 2 ">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>循环周期:</label>
                </v-col>
                <v-col cols="7">
                  <v-select
                      :rules="[rules.required]"
                      v-model="edit.item.week"
                      :items="edit.weekList"
                      item-text="name"
                      item-value="id"
                      label=""
                      multiple
                      outlined
                      dense
                      clearable
                  ></v-select>
                </v-col>
              </v-row>
              <v-row align="center" v-if="edit.item.cycleType == 3 || edit.item.cycleType == 5">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>循环周期:</label>
                </v-col>
                <v-col cols="7">
                  <v-select
                      :rules="[rules.required]"
                      v-model="edit.item.day"
                      :items="edit.dayList"
                      item-text="name"
                      item-value="id"
                      label=""
                      multiple
                      outlined
                      dense
                      clearable
                  ></v-select>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>巡检开始日期:</label>
                </v-col>
                <v-col cols="7">
                  <date-picker :rules="[rules.required]" label="" v-model="edit.item.startDate"></date-picker>
                </v-col>
              </v-row>
                <v-row align="center">
                  <v-col cols="3" class="text-right">
                    <label><label class="red--text">*</label>巡检结束日期:</label>
                  </v-col>
                  <v-col cols="7">
                    <date-picker :rules="[rules.required]" label="" v-model="edit.item.endDate"></date-picker>
                  </v-col>
                </v-row>
              <v-row align="center">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>巡检时段:</label>
                </v-col>
                <v-col cols="7">
                  <el-time-picker
                      is-range
                      v-model="edit.item.timeRange"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      placeholder="选择时间范围"
                      value-format="HH:mm"
                  >
                  </el-time-picker>
                </v-col>
              </v-row>
              <v-row align="center" v-if="!edit.item.cycleType || edit.item.cycleType != 5">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>任务日期:</label>
                </v-col>
                <v-col cols="7">
                  <v-text-field outlined dense suffix="天" v-model="edit.item.taskDuration" :rules="[rules.required, rules.int]"></v-text-field>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>状态:</label>
                </v-col>
                <v-col cols="7">
                  <v-select :rules="[rules.required]" :items="edit.statusList" v-model="edit.item.status" item-value="id" item-text="name" outlined dense></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <label><label class="red--text">*</label>巡检点位类型:</label>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>点位设置方式:</label>
                </v-col>
                <v-col cols="7">
                  <v-radio-group row mandatory v-model="edit.item.pointType" class="ma-0 pa-0">
                    <v-radio
                        label="按类型"
                        :value="1"
                    ></v-radio>
                    <v-radio
                        label="按点位"
                        :value="2"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row v-if="edit.item.pointType == 1">
                <v-col cols="3" offset="1">
                  <v-text-field v-model="edit.pointName" outlined dense></v-text-field>
                </v-col>
                <v-col cols="1" >
                  <v-btn color="primary" depressed>搜索</v-btn>
                </v-col>
              </v-row>
              <v-row align="center" v-if="edit.item.pointType == 1">
                <v-col cols="4" offset="1">
                  <v-card outlined tile>
                    <v-data-table
                        v-model="edit.leftPointSelect"
                        :headers="edit.srcPointHead"
                        :items="leftPointType"
                        :single-select="false"
                        item-key="id"
                        show-select
                        class="elevation-1"
                        hide-default-footer
                        height="300"
                        :items-per-page="-1"
                    >
                      <template v-slot:[`item.pointName`]="{ item }">
                        {{ item.status === 0 ? item.pointName + "(停用)" : item.pointName }}
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
                <v-col cols="2" class="text-center">
                  <v-btn class="mb-2" @click="addPointType">添加 ></v-btn>
                  <v-btn @click="removePointType">< 移除</v-btn>
                </v-col>
                <v-col cols="4">
                  <v-card outlined tile>
                    <v-data-table
                        v-model="edit.rightPointSelect"
                        :headers="edit.dstPointHead"
                        :items="edit.item.pointTypeList"
                        :single-select="false"
                        item-key="id"
                        show-select
                        class="elevation-1"
                        hide-default-footer
                        height="300"
                        :items-per-page="-1"
                    >
                      <template v-slot:[`item.pointName`]="{ item }">
                        {{ item.status === 0 ? item.pointName + "(停用)" : item.pointName }}
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-if="edit.item.pointType == 2">
                <v-col cols="12">
                  <v-data-table hide-default-footer :headers="edit.pointHead" :items="edit.item.shopPointList" :items-per-page="-1">
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-btn color="primary" depressed class="mr-2" @click="clickImport('shopPoint')" >
                          导入点位
                        </v-btn>
                      </v-toolbar>
                    </template>

                    <template v-slot:[`item.status`]="{ item }">
                      {{ item.status === 0 ? "停用" : "启用" }}
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <label><label class="red--text">*</label>选择执行人:</label>
                </v-col>
              </v-row>
              <v-row align="center">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>执行人设置方式:</label>
                </v-col>
                <v-col cols="7">
                  <v-radio-group row mandatory v-model="edit.item.handlePersonType" class="ma-0 pa-0">
                    <v-radio
                        label="按岗位"
                        :value="1"
                    ></v-radio>
                    <v-radio
                        label="按人"
                        :value="2"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row align="center" v-if="edit.item.handlePersonType == 1">
                <v-col cols="3" class="text-right">
                  <label><label class="red--text">*</label>执行岗位:</label>
                </v-col>
                <v-col cols="7">
                  <v-select :rules="[rules.required]" :items="edit.roleList"  v-model="edit.item.executivePosition" item-value="id" item-text="roleName" outlined dense></v-select>
                </v-col>
              </v-row>
              <v-row v-if="edit.item.handlePersonType == 2">
                <v-col cols="12">
                  <v-data-table hide-default-footer :headers="edit.personHead" :items="edit.item.personList" :items-per-page="-1">
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-btn color="primary" depressed class="mr-2" @click="clickImport('person')" >
                          导入人员
                        </v-btn>
                      </v-toolbar>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
                <v-row align="center">
                  <v-col cols="3" class="text-right">
                    <label><label class="red--text">*</label>统计方式:</label>
                  </v-col>
                  <v-col cols="7">
                    <v-select :rules="[rules.required]" :items="edit.statTypeList" v-model="edit.item.statType" item-value="id" item-text="name" outlined dense></v-select>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="saveItem"> 保存 </v-btn>
            <v-btn text @click="edit.dialog = false"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--导入弹窗-->
      <v-dialog v-model="importData.dialog" width="600">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2"
          >{{ importData.title }}</v-card-title
          >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col>
                  <v-file-input
                      truncate-length="15"
                      label="选择excel"
                      small-chips
                      dense
                      v-model="importData.importFile"
                  ></v-file-input>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="handleImport"> 确认 </v-btn>
            <v-btn color="primary" text @click="downloadTemplate">
              下载模板
            </v-btn>
            <v-btn text @click="hideImport"> 取消 </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import TaskApi from "@/api/pd/inspection/TaskApi";
import {default as downloadUtil} from "@/util/downloadUtil";
import {default as PermissionApi} from "@/api/smp/auth/Permission";
import StaffingApi from "@/api/pd/maintenance/role/RoleApi";
import ShopPointApi from "@/api/pd/inspection/ShopPointApi";
import PdForumApi from "@/api/pd/forum/PdForumApi.js";
export default {
  name: "Pd-Manager-Task",
  props: {
    page: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {
      rules:{
        required: value => (((!Array.isArray(value) &&!!value) || (Array.isArray(value) && value.length > 0)) || value === 0) || '必填.',
        int:value => ((!value && value !== 0)||(!isNaN(parseInt(value)) && value > 0)) || '只能输入正整数',
      },
      buttonPriviledgeList: [],
      filter: {
        taskName: "",
        shopIds:[],
        pageNum: 1,
        pageSize: 15,
      },
      headers: [
        {
          text: "任务名称",
          value: "taskName",
          sortable: false,
          width: 100,
          divider: true,
          groupable: false
        },
        {
          text: "适用门店",
          value: "shopNames",
          sortable: false,
          width: 150,
          divider: true,
        },
        {
            text: "所属版块",
            value: "forumName",
            sortable: false,
            width: 100,
            divider: true,
        },
        {
          text: "任务类型",
          align: "start",
          sortable: false,
          value: "taskType",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "循环类型",
          align: "start",
          sortable: false,
          value: "cycleType",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "统计方式",
          align: "start",
          sortable: false,
          value: "statType",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "巡检周期",
          align: "start",
          sortable: false,
          value: "startDate",
          width: 150,
          divider: true,
          groupable: false
        },
        {
          text: "巡检时段",
          align: "start",
          sortable: false,
          value: "startTime",
          width: 100,
          divider: true,
          groupable: false
        },
        {
          text: "任务日期",
          align: "start",
          sortable: false,
          value: "taskDuration",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "状态",
          align: "start",
          sortable: false,
          value: "status",
          width: 80,
          divider: true,
          groupable: false
        },
        {
          text: "最后修改人",
          align: "start",
          sortable: false,
          value: "updateBy",
          width: 100,
          divider: true,
          groupable: false
        },
        {
          text: "最后修改时间",
          align: "start",
          sortable: false,
          value: "updateTime",
          width: 150,
          divider: true,
          groupable: false
        },
        {
          text: "操作",
          align: "start",
          sortable: false,
          value: "actions",
          width: 150,
          divider: true,
          groupable: false
        },
      ],
      desserts: [],
      loading: false,
      totalDesserts: 0,
      valid: false,
      edit:{
        title:'',
        item: {
          id:null,
          taskName:'',
          shopIds:[],
          week:[],
          day:[],
          executivePosition:null,
          taskType:null,
          cycleType:null,
          startDate:'',
          endDate:'2099-12-31',
          timeRange:['00:00', '23:59'],
          pointType:1,
          pointTypeList:[],
          shopPointList:[],
          handlePersonType:1,
          personList:[],
          statType:null,
        },
        dialog:false,
        roleList:[],
        taskTypeList:[{id:1, name:'周期任务'}],
        cycleTypeList:[{id:1,name:'日'},{id:2,name:'周'},{id:3,name:'月'},{id:4,name:'季'},{id:5,name:'自然月'}],
        statTypeList:[{id:1,name:'周任务'},{id:2,name:'月任务'},{id:3,name:'半月任务'},{id:4,name:'日任务'},{id:5,name:'季度任务'}],
        weekList:[{id:'1',name:'周一'},{id:'2',name:'周二'},{id:'3',name:'周三'},{id:'4',name:'周四'},{id:'5',name:'周五'},{id:'6',name:'周六'},{id:'7',name:'周日'}],
        dayList:[],
        statusList:[{id:1,name:'启用'}, {id:2,name:'停用'}],
        forumList: [],
        pointName:'',
        allPointType:[],
        leftPointSelect:[],
        rightPointSelect:[],
        srcPointHead:[{
          text: "源列表",
          value: "pointName",
          sortable: false,
          width: 100,
        },],
        dstPointHead:[{
          text: "目标列表",
          value: "pointName",
          sortable: false,
          width: 100,
        },],
        pointHead:[
          {
            text: "点位编号",
            value: "pointCode",
            sortable: false,
            width: 100,
          },
          {
            text: "所属门店",
            value: "shopName",
            sortable: false,
            width: 100,
          },
          {
            text: "点位名称",
            value: "pointName",
            sortable: false,
            width: 100,
          },
          {
            text: "点位分类",
            value: "pointType",
            sortable: false,
            width: 100,
          },
          {
            text: "位置",
            value: "location",
            sortable: false,
            width: 100,
          },
          {
            text: "状态",
            value: "status",
            sortable: false,
            width: 100,
          },
        ],
        personHead:[
          {
            text: "人员ID",
            value: "userId",
            sortable: false,
            width: 100,
          },
          {
            text: "所属门店",
            value: "shopName",
            sortable: false,
            width: 100,
          },
          {
            text: "人员姓名",
            value: "userName",
            sortable: false,
            width: 100,
          },
          {
            text: "岗位",
            value: "roleName",
            sortable: false,
            width: 100,
          },
          {
            text: "手机号码",
            value: "mobile",
            sortable: false,
            width: 100,
          },
        ]
      },
      importData:{
        dialog:false,
        title:'',
        importFile:null,
        importType:'',
      }
    };
  },
  computed:{
    leftPointType: function (){
      let pointList = this.edit.allPointType.filter(point=>{
        return !this.edit.item.pointTypeList.some(pointType => pointType.id === point.id)
      })
      if (this.edit.item.forumId) {
          pointList = pointList.filter(point => point.forumId === this.edit.item.forumId)
      }
      if(this.edit.pointName){
        pointList = pointList.filter(point=>point.pointName.indexOf(this.edit.pointName) >=0);
      }
      return pointList;
    }
  },
  watch:{
    'edit.item.cycleType'(val){
      if(val == 5 || val == 3){
        this.getDayList(val);
        if(val == 5 && this.edit.item.day){
          let index = this.edit.item.day.indexOf('00');
          if(index >=0){
            this.edit.item.day.splice(index,1);
          }
        }
      }
    }
  },
  mounted() {
    this.getButtonPriviledge();
    this.getDataFromApi();
    this.getRoleList();
    // this.getDayList();
    this.allPointType();
    this.getForumList();
  },
  methods: {
    // 点击导入
    clickImport(type) {
      this.importData.dialog = true;
      this.importData.importFile = null;
      this.importData.importType = type;
      switch (this.importData.importType){
        case "shopPoint":
          this.importData.title='导入门店点位';
          break;
        case "person":
          this.importData.title='导入人员';
          break;
      }
    },
    hideImport() {
      this.importData.dialog = false;
      this.importData.importFile = null;
    },
    async downloadTemplate() {
      let me = this;
      let res = null;
      let fileName = '';
      switch (this.importData.importType){
        case "shopPoint":
          fileName = '门店点位导入模板.xlsx';
          res = await TaskApi.shopPointTemplate();
          break;
        case "person":
          fileName = '人员导入模板.xlsx'
          res = await TaskApi.personTemplate();
          break;
      }
      downloadUtil.downloadByBlob({ res: res.data, fileName: fileName });
    },
    async handleImport() {
      let me = this;
      let file = me.importData.importFile;
      if (!file || !file.size) {
        me.$dialog.error({
          text: "文件必传",
          title: "操作失败",
        });
        return;
      }
      if(this.importData.importType == 'shopPoint'){
        let res = await TaskApi.importShopPoint(file);
        console.log("导入结果", res);
        if (res.data.code === 200) {
          me.edit.item.shopPointList = res.data.data;
        } else {
          me.$dialog.error({
            text: res.data.msg + ':' + res.data.msg_detail,
            title: "操作失败",
          });
        }
      }else if(this.importData.importType == 'person'){
        let res = await TaskApi.importPerson(file);
        console.log("导入结果", res);
        if (res.data.code === 200) {
          me.edit.item.personList = res.data.data;
        } else {
          me.$dialog.error({
            text: res.data.msg + ':' + res.data.msg_detail,
            title: "操作失败",
          });
        }
      }
 
                me.hideImport();
            },
            handleSearch() {
                this.filter.pageNum = 1
                this.getDataFromApi();
            },
            handleResetSearch() {
                this.filter = {
                    taskName: "",
                    shopIds: [],
                    pageNum: 1,
                    pageSize: 15,
                };
                this.getDataFromApi();
            },
            handlePageChanged(pageNum) {
                this.filter.pageNum = pageNum;
                this.getDataFromApi();
            },
            handlePageSizeChanged(pageSize) {
                if (pageSize == -1) {
                    pageSize = 100;
                }
                this.filter.pageNum = 1;
                this.filter.pageSize = pageSize;
                this.getDataFromApi();
            },
            getQueryParams(query) {
                return query;
            },
            async getDataFromApi() {
                let me = this;
                me.loading = true;
                let queryUserResp = await TaskApi.list({
                    taskName: me.filter.taskName,
                    shopIds: me.filter.shopIds.join(','),
                    pageNum: me.filter.pageNum,
                    pageSize: me.filter.pageSize,
                });
                console.log("load user returned;");
                console.log(queryUserResp);
                let data = queryUserResp.data;
                if (!data || !data.code || data.code != 200) {
                    let msg = data.msg;
                    msg = !msg || msg == "" ? "获取巡检任务失败" : msg;
                    me.loading = false;
                    throw new Error(msg);
                }
                if (!data.data || !data.data.rows) {
                    me.loading = false;
                    throw new Error("获取巡检任务失败(无会话数据)");
                }
                me.loading = false;
                me.desserts = data.data.rows;
                me.totalDesserts = data.data.total;
                me.loading = false;
            },
 
            add() {
                this.edit.title = '新建巡检任务';
                this.edit.item = {
                    id: null,
                    taskName: '',
                    shopIds: [],
                    executivePosition: null,
                    taskType: null,
                    cycleType: null,
                    week: [],
                    day: [],
                    startDate: '',
                    endDate: '2099-12-31',
                    timeRange: ['00:00', '23:59'],
                    pointType: 1,
                    pointTypeList: [],
                    shopPointList: [],
                    handlePersonType: 1,
                    personList: [],
                };
                if (this.$refs.taskForm) {
                    this.$refs.taskForm.resetValidation();
                }
                this.edit.dialog = true;
            },
 
            getButtonPriviledge() {
                console.log('this.page', this.page)
                let menuId = this.page.id
                let me = this
                PermissionApi.queryButtonPriviledge(menuId, null).then(resp => {
                    PermissionApi.handleResponse(resp, me, function(data) {
                        me.buttonPriviledgeList = data.buttonPriviledges
                        console.log('buttonPriviledgeList', me.buttonPriviledgeList)
                    })
                })
            },
            _hasButtonPermission(name) {
                let buttonPriviledgeList = this.buttonPriviledgeList;
                let hasButton = false;
                for (let i = 0; i < buttonPriviledgeList.length; i++) {
                    if (buttonPriviledgeList[i].name == name) {
                        if (buttonPriviledgeList[i].hasPriviledge == "Y") {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
                return false;
            },
            async disableItem(item) {
                let me = this;
                let confirm = await me.$dialog.confirm({
                    text: "确认停用巡检任务吗？",
                    title: "提示",
                });
                if (confirm) {
                    let res = await TaskApi.changeStatus(item.id, 0);
                    if (res.data.code === 200) {
                        me.$dialog.info({
                            text: res.data.msg,
                            title: "操作成功",
                        });
                        me.getDataFromApi();
                    } else {
                        me.$dialog.error({
                            text: res.data.msg,
                            title: "操作成功",
                        });
                    }
                }
            },
            async enableItem(item) {
                let me = this;
                let confirm = await me.$dialog.confirm({
                    text: "确认启用巡检任务吗？",
                    title: "提示",
                });
                if (confirm) {
                    let res = await TaskApi.changeStatus(item.id, 1);
                    if (res.data.code === 200) {
                        me.$dialog.info({
                            text: res.data.msg,
                            title: "操作成功",
                        });
                        me.getDataFromApi();
                    } else {
                        me.$dialog.error({
                            text: res.data.msg,
                            title: "操作成功",
                        });
                    }
                }
            },
            async getRoleList() {
                let res = await StaffingApi.getRoleList();
                if (res.data.code === 200) {
                    this.edit.roleList = res.data.data;
                } else {
                    me.$dialog.error({
                        text: res.data.msg,
                        title: "操作失败",
                    });
                }
            },
            getDayList(cycleType) {
                let dayList = [];
                for (let i = 1; i <= 31; i++) {
                    dayList.push({
                        id: (Array(2).join(0) + i).slice(-2),
                        name: i + "号"
                    });
                }
                if (!cycleType || cycleType != 5) {
                    dayList.push({
                        id: '00',
                        name: "最后一天"
                    })
                }
                this.edit.dayList = dayList;
            },
            async getForumList() {
                let res = await PdForumApi.all();
                if (res.status === 200) {
                    this.edit.forumList = res.data.data;
                }
            },
            async allPointType() {
                let res = await TaskApi.allPointType();
                if (res.data.code === 200) {
                    this.edit.allPointType = res.data.data;
                } else {
                    me.$dialog.error({
                        text: res.data.msg,
                        title: "操作失败",
                    });
                }
            },
            addPointType() {
                let select = this.edit.leftPointSelect;
                if (select.length > 0) {
                    this.edit.item.pointTypeList = this.edit.item.pointTypeList.concat(select);
                }
                this.edit.leftPointSelect = [];
            },
            removePointType() {
                let select = this.edit.rightPointSelect;
                if (select.length > 0) {
                    this.edit.item.pointTypeList = this.edit.item.pointTypeList.filter(pointType => !select.some(point => point.id ===
                        pointType.id));
                }
                this.edit.rightPointSelect = [];
            },
            async editItem(item) {
                let queryUserResp = await TaskApi.detail({
                    taskId: item.id
                });
                let data = queryUserResp.data;
                if (!data || !data.code || data.code != 200) {
                    let msg = data.msg;
                    msg = !msg || msg == "" ? "获取巡检任务详情失败" : msg;
                    throw new Error(msg);
                }
                let task = data.data;
                task.shopIds = task.shopIds.map(shopId => shopId + '');
                if (task.cycleType == 2) {
                    task.week = task.cycleRule.split(',');
                } else if (task.cycleType == 3 || task.cycleType == 5) {
                    task.day = task.cycleRule.split(',');
                }
                task.timeRange = [task.startTime, task.endTime];
                if (task.pointType == 1) {
                    task.pointTypeList = this.edit.allPointType.filter(pointType => task.pointIds.some(pointId => pointId.pointId ==
                        pointType.id));
                } else if (task.pointType == 2) {
                    task.shopPointList = task.shopPoints.map(shopPoint => {
                        let point = Object.assign({}, shopPoint);
                        point.id = point.pointId;
                        return point;
                    });
                }
                if (task.handlePersonType == 2) {
                    task.personList = task.personIds;
                }
                console.log(task);
                this.edit.item = task;
                this.edit.title = '编辑巡检任务';
                this.edit.dialog = true;
            },
            async saveItem() {
                console.log(this.edit.item);
                let valid = this.$refs.taskForm.validate();
                if (valid) {
                    let item = this.edit.item;
                    if (!item.shopIds || item.shopIds.length == 0) {
                        this.$dialog.error({
                            title: '错误',
                            text: '请选择适用门店'
                        })
                        return
                    }
                    if (!item.timeRange || item.timeRange.length == 0) {
                        this.$dialog.error({
                            title: '错误',
                            text: '请选择巡检时段'
                        })
                        return
                    }
                    if (item.pointType == 1) {
                        if (!item.pointTypeList || item.pointTypeList.length == 0) {
                            this.$dialog.error({
                                title: '错误',
                                text: '请选择点位类型'
                            })
                            return
                        }
                    }
                    if (item.pointType == 2) {
                        if (!item.shopPointList || item.shopPointList.length == 0) {
                            this.$dialog.error({
                                title: '错误',
                                text: '请导入门店点位'
                            })
                            return
                        }
                    }
                    if (item.handlePersonType == 2) {
                        if (!item.personList || item.personList.length == 0) {
                            this.$dialog.error({
                                title: '错误',
                                text: '请导入执行人员'
                            })
                            return
                        }
                    }
                    if (item.cycleType == 2) {
                        item.cycleRule = item.week.join(",");
                    } else if (item.cycleType == 3 || item.cycleType == 5) {
                        item.cycleRule = item.day.join(',');
                    }
                    item.startTime = item.timeRange[0];
                    item.endTime = item.timeRange[1];
                    let pointList = [];
                    if (item.pointType == 1) {
                        pointList = item.pointTypeList.map(pointType => {
                            return {
                                pointId: pointType.id
                            }
                        });
                    } else if (item.pointType == 2) {
                        pointList = item.shopPointList.map(shopPoint => {
                            return {
                                pointId: shopPoint.id,
                                shopId: shopPoint.shopId
                            }
                        })
                    }
                    item.pointIds = pointList;
 
                    if (item.handlePersonType == 2) {
                        let personList = item.personList.map(person => {
                            return {
                                userId: person.userId,
                                shopId: person.shopId
                            }
                        });
                        item.personIds = personList;
                    }
 
                    let res = null;
                    if (item.id) {
                        res = await TaskApi.update(item);
                    } else {
                        res = await TaskApi.saveTask(item);
                    }
                    if (res.data.code === 200) {
                        this.$dialog.info({
                            text: res.data.msg,
                            title: "操作成功",
                        });
                        this.edit.dialog = false;
                        this.getDataFromApi();
                    } else {
                        this.$dialog.error({
                            text: res.data.msg + ':' + res.data.msg_detail,
                            title: "操作失败",
                        });
                    }
                }
            },
            async doExport() {
                let res = await TaskApi.exportData({
                    taskName: this.filter.taskName,
                    shopIds: this.filter.shopIds.join(','),
                    pageNum: this.filter.pageNum,
                    pageSize: this.filter.pageSize,
                });
                downloadUtil.downloadByBlob({
                    res: res.data,
                    fileName: "导出结果.xlsx"
                });
            }
        },
    };
</script>
<style scoped>
</style>